module.exports = {
  isValid: true
};
